import classNames from 'classnames';
import { IconProps } from './types';
import { Undo as UndoIcon } from '@carbon/react/icons';

import style from './icons.module.scss';

const Undo = ({ className }: IconProps) => {
  return (
    <div className={classNames(style.background, style.undo, className)}>
      <UndoIcon size={32} className={classNames(style.icon, style.undo)} />
    </div>
  );
};

export default Undo;
